import { SyncDescriptor } from 'vscode/vscode/vs/platform/instantiation/common/descriptors';
import { ISearchService } from 'vscode/vscode/vs/workbench/services/search/common/search.service';
import { SearchService } from './vscode/src/vs/workbench/services/search/common/searchService.js';
import { SearchViewModelWorkbenchService } from 'vscode/vscode/vs/workbench/contrib/search/browser/searchModel';
import { ISearchViewModelWorkbenchService } from 'vscode/vscode/vs/workbench/contrib/search/browser/searchModel.service';
import { SearchHistoryService } from './vscode/src/vs/workbench/contrib/search/common/searchHistoryService.js';
import { ISearchHistoryService } from 'vscode/vscode/vs/workbench/contrib/search/common/searchHistoryService.service';
import { IReplaceService } from 'vscode/vscode/vs/workbench/contrib/search/browser/replace.service';
import { ReplaceService } from './vscode/src/vs/workbench/contrib/search/browser/replaceService.js';
import { RemoteSearchService } from './vscode/src/vs/workbench/services/search/browser/searchService.js';
import './vscode/src/vs/workbench/contrib/search/browser/search.contribution.js';
import './vscode/src/vs/workbench/contrib/searchEditor/browser/searchEditor.contribution.js';

function getServiceOverride({ useHtmlFileSystemProvider = false } = {}) {
    return {
        [( ISearchService.toString())]: useHtmlFileSystemProvider ? new SyncDescriptor(RemoteSearchService, [], true) : new SyncDescriptor(SearchService, [], true),
        [( ISearchViewModelWorkbenchService.toString())]: new SyncDescriptor(SearchViewModelWorkbenchService, [], true),
        [( ISearchHistoryService.toString())]: new SyncDescriptor(SearchHistoryService, [], true),
        [( IReplaceService.toString())]: new SyncDescriptor(ReplaceService, [], true)
    };
}

export { getServiceOverride as default };
